import { authErrorContent, type AuthErrorContent, type AuthErrorLocale } from './auth-error-message.content'

/** The error shape better-auth's client returns (`result.error`). */
export interface AuthClientError {
  status?: number
  code?: string
  message?: string
}

/**
 * Text shown for a failed sign-in or sign-up.
 *
 * A 429 (the API's Redis limiter answers `{code: 'RATE_LIMITED'}` with no
 * `message`; better-auth's own limiter also answers 429) is "too many
 * attempts", never the fallback: before W4-3 a rate-limited student with the
 * right password read "invalid credentials", retried and stayed blocked.
 */
export function authErrorMessage(
  error: AuthClientError,
  fallback: Exclude<keyof AuthErrorContent, 'rateLimited'>,
  locale: AuthErrorLocale = 'pt',
): string {
  const content = authErrorContent[locale]
  if (error.status === 429 || error.code === 'RATE_LIMITED') return content.rateLimited
  return error.message || content[fallback]
}

